import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the element whose id matches the current #hash.
// Needed because React Router does not do this automatically.
export default function useScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
      return;
    }
    const id = hash.replace("#", "");
    // Wait a tick so the target section has rendered first.
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 60);
    return () => clearTimeout(timer);
  }, [hash, pathname]);
}